"use strict";
/**
 * Copyright © 2020-2022 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoreMapPath = exports.readAndParseJsonFile = exports.downloadFileFromUrl = exports.humanReadableSize = exports.readAsDataUrlSync = exports.compressFiles = exports.isFileType = void 0;
var jszip_1 = __importDefault(require("jszip"));
var isFileType = function (file, type) {
    var pattern = new RegExp('\\.' + type + '$');
    return pattern.test(file.name);
};
exports.isFileType = isFileType;
var compressFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
    var zip, _i, files_1, file, generatedZip;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                zip = new jszip_1.default();
                for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
                    file = files_1[_i];
                    zip.file(file.path, file);
                }
                return [4 /*yield*/, zip.generateAsync({ type: 'blob' })];
            case 1:
                generatedZip = _a.sent();
                return [2 /*return*/, generatedZip];
        }
    });
}); };
exports.compressFiles = compressFiles;
var bufferToString = function (buffer) {
    return String.fromCharCode.apply(null, Array.from(new Uint16Array(buffer)));
};
var readAsDataUrlSync = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var resultBase64;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        var result = reader.result;
                        if (result instanceof ArrayBuffer) {
                            resolve(bufferToString(result));
                            return;
                        }
                        resolve(result || undefined);
                    };
                    reader.readAsDataURL(file);
                })];
            case 1:
                resultBase64 = _a.sent();
                return [2 /*return*/, resultBase64];
        }
    });
}); };
exports.readAsDataUrlSync = readAsDataUrlSync;
var humanReadableSize = function (bytes, precision) {
    var index = Math.floor(Math.log(bytes) / Math.log(1024));
    var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var roughSize = bytes / Math.pow(1024, index);
    var roundedSize = precision
        ? parseFloat(roughSize.toFixed(precision)) * 1
        : Math.round(roughSize);
    return "".concat(roundedSize, " ").concat(sizes[index]);
};
exports.humanReadableSize = humanReadableSize;
var downloadFileFromUrl = function (downloadUrl) {
    var link = document.createElement('a');
    link.href = downloadUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
exports.downloadFileFromUrl = downloadFileFromUrl;
var readAndParseJsonFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var jsonResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                    var fileReader = new FileReader();
                    fileReader.addEventListener('load', function (e) {
                        if (typeof fileReader.result === 'string') {
                            try {
                                var json = JSON.parse(fileReader.result);
                                resolve(json);
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                    });
                    fileReader.readAsText(file);
                })];
            case 1:
                jsonResult = _a.sent();
                return [2 /*return*/, jsonResult];
        }
    });
}); };
exports.readAndParseJsonFile = readAndParseJsonFile;
var formatDir = function (value) {
    return value.toLowerCase().split(' ').join('-');
};
var getStoreMapPath = function (store) {
    if (store && store.address) {
        var address = store.address, category = store.category;
        var state = address.state, city = address.city;
        return "".concat(formatDir(state), "/").concat(formatDir(city), "/").concat(category);
    }
    return null;
};
exports.getStoreMapPath = getStoreMapPath;
